import React from 'react';

import { Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import Onboard from 'pages/Dashboard/Onboard/Onboard';
import { InviteType } from 'constants/enums';

interface IBulkOrderDevicesProps {
  close: any;
}

const BulkOrderDevices = ({ close }: IBulkOrderDevicesProps) => {
  const intl = useIntl();

  return (
    <Modal show onHide={close} size="xl" backdrop="static" data-test="bulk-order-modal">
      <Modal.Header className="align-items-center" closeButton>
        <Modal.Title>{intl.formatMessage({ id: 'bulkOrderDevicesKey' })}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-0">
        <div className="position-relative">
          <Onboard
            inviteType={InviteType.BULK_ORDER_DEVICES}
            fallback={(status: boolean) => close(status)}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BulkOrderDevices;
